import { Container, Row, Col } from "react-bootstrap"
import { useEffect, useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import { StartFlow } from "./StartFlow"
import { EmailOtp } from "./EmailOtp"
import { Passkey } from "./Passkey"
import { useLocation, useNavigate } from "react-router-dom"

export const PasskeyManagement = () => {
  const [email, setEmail] = useState("")
  const [session, setSession] = useState<string | null>(null)
  const location = useLocation()
  const navigate = useNavigate()
  const clientId: string = location.state?.clientId
  const [webAuthnParams, setWebauthnParams] = useState<any | null>(null) // FIXME any?

  const startSignIn = async (enteredEmail: string) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/sign-in/start`, {
        email: enteredEmail,
        clientId,
        preferredChallenge: "email-otp"
      })

      const data = response.data

      setEmail(enteredEmail)
      setSession(data.session)
    } catch (error) {
      console.error(error)
      toast.error("Unexpected error")
    }
  }

  const sendEmailOtp = async (code: string) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/passkeys/auth`, {
        session,
        email,
        code,
        clientId
      })

      setWebauthnParams(response.data.creationParams)
    } catch (error) {
      console.error(error)
      toast.error("Unexpected error")
    }
  }

  const sendWebAuthnResponse = async (response: any) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/passkeys/create`, {
        session,
        email,
        credential: response
      })
      toast.success("Passkey added successfully") // TODO timeout
      reset()
    } catch (error) {
      console.error(error)
      toast.error("Unexpected error")
    }
  }

  const reset = () => {
    setSession(null)
    setWebauthnParams(null)
  }

  useEffect(() => {
    if (!clientId) {
      toast.error("Missing client ID")
      navigate("/error")
    }
  }, [clientId, navigate])

  return <>
    <Container>
      <Row>
        <Col>
          <h3>Passkeys</h3>
          {!session ?
            <StartFlow onSubmit={startSignIn} /> :
            (webAuthnParams ?
              <Passkey webAuthnParams={webAuthnParams} onSuccess={sendWebAuthnResponse} onCancel={reset} /> :
              <EmailOtp onSubmit={sendEmailOtp} onCancel={reset} />
            )
          }
        </Col>
      </Row>
    </Container>
  </>
}
